import { useTranslation } from "react-i18next";
import { useOperationsMap } from "../OperationsMapProvider";
import TaskItem from "../../dispatch/common/TaskItem";
import { useDevice } from "../../../../providers/DeviceProvider";
import { Box, CircularProgress, Divider, Grid } from "@mui/material";
import EmptyState from "../../../common/core/EmptyState";
import { makeStyles } from "tss-react/mui";
import { Fragment, useCallback } from "react";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: theme.spacing(1.5),
      paddingTop: theme.spacing(2)
    },
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    loader: {
      paddingTop: "128px"
    },
  })
);

export default function ActiveTasksPanel() {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const {
    filteredTasks,
    initialLoad,
    dispatchLayerHoverId,
    operationsMap,
    openTaskDialog
  } = useOperationsMap();

  const showLoading = !initialLoad;

  const { slim } = useDevice();

  const onHover = useCallback((id = "none") => {
    operationsMap?.getPlugin("dispatch")?.setHighlightHighContrast(id);
  }, [operationsMap])

  return (
    <Box className={classes.root}>
      <Grid container>


        {
          showLoading ? (
            <Grid item xs={12} container justifyContent="center" alignItems="center" className={classes.loader}>
              <Grid item>
                <CircularProgress variant="indeterminate" size={"48px"} />
              </Grid>
            </Grid>
          ) : filteredTasks.length === 0 ? (
            <EmptyState
              title={t("operationsMap:tasksEmptyStateTitle")}
              description={t("operationsMap:tasksEmptyStateDescription")}
            />
          ) : filteredTasks.map((t, i) => (
            <Fragment key={i}>
              <TaskItem
                slim={slim}
                missionTask={t}
                highlight={dispatchLayerHoverId === t.id}
                onMouseEnter={() => onHover(t.id)}
                onMouseLeave={() => onHover()}
                onClick={(ev) => {
                  ev.preventDefault();
                  openTaskDialog(t.id);
                }}
              />

              {i !== filteredTasks.length - 1 || slim ? (
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                </Grid>
              ) : null}

            </Fragment>
          ))}

      </Grid>
    </Box>
  );
}

